module.exports = __webpack_public_path__ + "img/antes_despues_232.d8038e29.png";